import { CatalogBrandsUrlParams } from '../schema/catalog-brands.schema'

export const createCatalogBrandsUrlParams = (query: CatalogBrandsUrlParams) => {
	const { sort, page = 1 } = query
	const [order, direction] = sort?.split(`|`) || []

	return {
		limit: `32`,
		order: order || `popular`,
		...(page && { page: `${page}` }),
		...(direction && { direction })
	}
}
